import { getDefaultStore } from 'jotai';
import { mcpBridgeStatusAtom } from './mcpBridgeStatusAtom';

export class MCPBridgeSession {
  setConnecting(): void {
    getDefaultStore().set(mcpBridgeStatusAtom, { kind: 'connecting' });
  }

  setConnected(): void {
    getDefaultStore().set(mcpBridgeStatusAtom, { kind: 'connected' });
  }

  setDisconnected(reason?: string): void {
    if (reason === undefined) {
      getDefaultStore().set(mcpBridgeStatusAtom, { kind: 'disconnected' });
    } else {
      getDefaultStore().set(mcpBridgeStatusAtom, { kind: 'disconnected', reason });
    }
  }
}
